import type { TextBlock } from "@/lib/structured-text";
import { claimMarkers, type ClaimMarkerScheme } from "./claim-markers";

/** The schemes a matter can mark its claim lines in: a) then i), or i) then a) (decision 43). */
export const MARKER_SCHEMES: readonly {
  scheme: ClaimMarkerScheme;
  name: string;
}[] = [
  { scheme: "a-i", name: "Letters, then romans" },
  { scheme: "i-a", name: "Romans, then letters" },
];

/** A preamble, two elements, and a sub-element: the shortest shape telling the levels apart. */
const SAMPLE: TextBlock[] = [
  { runs: [], depth: 0, numbered: false },
  { runs: [], depth: 1, numbered: true },
  { runs: [], depth: 1, numbered: true },
  { runs: [], depth: 2, numbered: true },
];

/**
 * How a scheme reads, drawn by the projection that draws the claims.
 *
 * Asked for rather than written down beside the name: a chooser showing markers
 * the editor does not draw is the one way this feature can lie, and a second
 * table would need a test to say it never does.
 */
export function sampleMarkers(scheme: ClaimMarkerScheme): string[] {
  return claimMarkers(SAMPLE, scheme).filter((one) => one !== null);
}
